import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import PhoneNumberInput from '../../common/PhoneNumberInput';

const PhoneNumberComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Phone Number Input Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PhoneNumberInput
                                    name="primaryPhone"
                                    id="primaryPhoneInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter your phone number"
                                    showHelp={true}
                                    helpText="Please enter your phone number, including country code."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PhoneNumberInput
    name="primaryPhone"
    id="primaryPhoneInput"
    required={true}
    layout="below"
    placeholder="Enter your phone number"
    showHelp={true}
    helpText="Please enter your phone number, including country code."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PhoneNumberInput
                                    name="businessPhone"
                                    id="businessPhoneInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter your business phone number"
                                    showHelp={true}
                                    helpText="This is required for business inquiries."
                                    showFlags={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PhoneNumberInput
    name="businessPhone"
    id="businessPhoneInput"
    required={true}
    layout="below"
    placeholder="Enter your business phone number"
    showHelp={true}
    helpText="This is required for business inquiries."
    showFlags={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PhoneNumberInput
                                    name="optionalPhone"
                                    id="optionalPhoneInput"
                                    required={false}
                                    layout="below"
                                    placeholder="Enter your optional phone number"
                                    showHelp={true}
                                    helpText="This field is optional."
                                    showFlags={false}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PhoneNumberInput
    name="optionalPhone"
    id="optionalPhoneInput"
    required={false}
    layout="below"
    placeholder="Enter your optional phone number"
    showHelp={true}
    helpText="This field is optional."
    showFlags={false}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PhoneNumberInput
                                    name="secondaryPhone"
                                    id="secondaryPhoneInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter secondary phone number"
                                    showHelp={true}
                                    helpText="This is required for secondary access."
                                    showFlags={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PhoneNumberInput
    name="secondaryPhone"
    id="secondaryPhoneInput"
    required={true}
    layout="below"
    placeholder="Enter secondary phone number"
    showHelp={true}
    helpText="This is required for secondary access."
    showFlags={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default PhoneNumberComponent;
